export default __webpack_public_path__ + "static/media/User.08d9617b.svg";